/**
 * East Africa Time — the one place new code gets the Nairobi offset from.
 * `Africa/Nairobi` is UTC+3 all year (no DST). Work dates and hour buckets
 * are EAT, never a bare UTC day.
 */
export const EAT_OFFSET_MIN = 180;
export const EAT_TIME_ZONE = 'Africa/Nairobi';
